angular.module('dentalLinks')
    .controller('FromProviderController', ['$scope', 'User',
        function ($scope, User) {
            // list all providers from the practice.
            // Only fetch if user is authenticated with a valid practice_id
            if ($scope.auth && $scope.auth.practice_id) {
                $scope.currentPracticeProviders = User.getProviders({practice_id: $scope.auth.practice_id});
            } else {
                $scope.currentPracticeProviders = [];
            }
        }
    ]);
